import { subDays } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { z } from "zod";

export const DEFAULT_DAYS_DIFF = 28;

export const convertToUTCDate = (date: Date) => {
  return date.toISOString();
};

const now = new Date();

export const DEFAULT_END_DATE = formatInTimeZone(
  now,
  "UTC",
  "yyyy-MM-dd'T'23:59:59'Z'"
);
export const DEFAULT_START_DATE = formatInTimeZone(
  subDays(now, DEFAULT_DAYS_DIFF),
  "UTC",
  "yyyy-MM-dd'T'00:00:00'Z'"
);

export const dateRangeSchema = z.object({
  from: z.string().optional().default(DEFAULT_START_DATE),
  to: z.string().optional().default(DEFAULT_END_DATE),
});

export type TDateRangeSchema = z.infer<typeof dateRangeSchema>;
